import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SurveyService } from '../services/surveyService';
import { ApplicationStorage } from '../services/applicationStorage';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.css'],
})
export class IntroComponent implements OnInit, OnDestroy {
  surveyIntroText: any;
  surveyType: any;

  surveySentences: string[] = [];
  shouldDisplayIntro: boolean = true;
  rejectGdpr: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private applicationStorage: ApplicationStorage,
    private surveyService: SurveyService
  ) { }

  // ngOnInit(): void {
  //   this.surveyIntroText = this.applicationStorage.storage.get("surveyIntroText");
  //   // this.surveyIntroText = this.surveyIntroText.replace(/([.!?])\s*(?=[A-Z0-9])/g, "$1<br>");

  //   this.sub = this.activatedRoute.params.subscribe((params: any) => {
  //     this.surveyId = params.surveyId;
  //     this.applicationStorage.storage.set("surveyId", this.surveyId);
  //   });
  // }

  // ngOnInit(): void {
  //   this.surveyIntroText = this.applicationStorage.storage.get("surveyIntroText");

  //   this.surveySentences = this.surveyIntroText?.split(". ");

  //   this.sub = this.activatedRoute.params.subscribe((params: any) => {
  //     this.surveyId = params.surveyId;
  //     this.applicationStorage.storage.set("surveyId", this.surveyId);
  //   });
  // }

  ngOnInit(): void {
    // alert('eeeeeee')

    this.surveyIntroText =
      this.applicationStorage.storage.get('surveyIntroText');
    this.surveyType = this.applicationStorage.storage.get('surveyType');
    localStorage.setItem("surveyType", this.surveyType)

    this.shouldDisplayIntro = !(
      this.surveyType == 'PLOOM3_1' ||
      this.surveyType == 'PLOOM3_12' ||
      this.surveyType == 'PLOOM3_3' ||
      this.surveyType == 'PLOOM3_6' ||
      this.surveyType == 'PLOOM4_1' ||
      this.surveyType == 'PLOOM4_3' ||
      this.surveyType == 'PLOOM4_6' ||
      this.surveyType == 'PLOOM4_12'
    );

    this.surveySentences = this.surveyIntroText?.match(/[^.?!]+[.?!]/g) || [];

    this.sub = this.activatedRoute.params.subscribe((params: any) => {
      // console.log(params)
      this.surveyId = params.surveyId;
      localStorage.setItem("surveyId", params.surveyId)

      this.applicationStorage.storage.set('surveyId', this.surveyId);
    });

    // check gdpr just for this forms
    if (
      this.surveyType == 'PLOOM3_1' ||
      this.surveyType == 'PLOOM3_12' ||
      this.surveyType == 'PLOOM3_3' ||
      this.surveyType == 'PLOOM3_6' ||
       this.surveyType == 'PLOOM4_1' ||
      this.surveyType == 'PLOOM4_12' ||
      this.surveyType == 'PLOOM4_3' ||
      this.surveyType == 'PLOOM4_6'
    ) {
      this.surveyService.getUserGdpr(this.surveyId)
        .subscribe({
          next: (data: any) => {
            this.shouldDisplayIntro = data?.gdpr_approval == true;
            this.rejectGdpr = data?.gdpr_approval == false ? true : false;
          },
          error: (error: any) => {
            console.error(error.message);
            alert('A aparut o eroare! Va rugam reveniti!')
          }
        })
    }

  }

  confirmGdpr(accepted: boolean): any {
    if (accepted) {
      console.log('Utilizatorul a acceptat GDPR');
      this.shouldDisplayIntro = true;
      this.surveyService.updateGdpr(this.surveyId, true).subscribe({
        next: (data: any) => {
          console.log(data);
        },
        error: (error: any) => {
          console.error(error.message);
          alert('A aparut o eroare! Va rugam reveniti!');
        },
      });
    } else {
      console.log('Utilizatorul a refuzat GDPR');
      this.surveyService.updateGdpr(this.surveyId, false).subscribe({
        next: (data: any) => {
          console.log(data);
          this.rejectGdpr = true;
        },
        error: (error: any) => {
          console.error(error.message);
          alert('A aparut o eroare! Va rugam reveniti!');
        },
      });
    }
  }
  // gdprAccepted: boolean = false;

  // onCheckboxChange(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   this.gdprAccepted = input.checked;
  // }


  gdprAccepted: boolean = false;
  showGdprError: boolean = false;
  showGdprHoverError: boolean = false;
  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.gdprAccepted = input.checked;
  }

  onStartClick(): void {
    if (!this.gdprAccepted) return; // extra siguranță

    this.surveyService.updateGdpr(this.surveyId, true).subscribe({
      next: () => {
        this.shouldDisplayIntro = true; // opțional: ascunde GDPR după confirmare
        this.router.navigate(['/survey', this.surveyId]);
      },
      error: (error) => {
        console.error('Eroare la update GDPR:', error);
        alert('A apărut o eroare la confirmarea GDPR. Te rugăm încearcă din nou.');
      }
    });
  }


  // onButtonHover(): void {
  //   if (!this.gdprAccepted) {
  //     this.showGdprHoverError = true;
  //   }
  // }

  // hideHoverError(): void {
  //   this.showGdprHoverError = false;
  // }
  // onSubmitGdpr(event: Event): void {
  //   event.preventDefault();
  //   if (this.gdprAccepted) {
  //     this.confirmGdpr(true);
  //   } else {
  //     this.showGdprError = true;
  //   }
  // }



  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  sub!: Subscription;
  surveyId!: string;
}
